import { render } from "./DisplayResultExempleMaladie.vue?vue&type=template&id=4cbb95e8&scoped=true"
import script from "./DisplayResultExempleMaladie.vue?vue&type=script&lang=js"
export * from "./DisplayResultExempleMaladie.vue?vue&type=script&lang=js"

import "./DisplayResultExempleMaladie.vue?vue&type=style&index=0&id=4cbb95e8&scoped=true&lang=scss"
/* hot reload */
if (module.hot) {
  script.__hmrId = "4cbb95e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cbb95e8', script)) {
    api.reload('4cbb95e8', script)
  }
  
  module.hot.accept("./DisplayResultExempleMaladie.vue?vue&type=template&id=4cbb95e8&scoped=true", () => {
    api.rerender('4cbb95e8', render)
  })

}


import exportComponent from "/data/tfs-agent-build-2/agent/_work/4/s/30-Frontend/Frontend/app/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbb95e8"],['__file',"src/components/DisplayResultExempleMaladie.vue"]])